export enum OtpValidationType {
  Sms,
  VoiceCall,
  Authenticator,
  CodeByEmail,
  RecoveryCode
}
